import React from 'react'
import { Head } from '@inertiajs/react'
import { router } from '@inertiajs/react'
import AdminLayout from '@/admin/shell/layouts/AdminLayout'
import DataTable from '@/admin/shared/components/DataTable/DataTable'
import { TableSearch } from '@/admin/shared/components/DataTable/Toolbar'
import { COLUMNS } from '../components/SubscriptionsTable'
import type { SubscriptionsPageProps } from '../types'

function SubscriptionsPage({ subscriptions, search }: SubscriptionsPageProps) {
  const navigate = (params: Record<string, string | number>) =>
    router.get('/admin/subscriptions', params as Record<string, string>, { preserveState: true, replace: true })

  return (
    <>
      <Head title="Admin — Subscriptions" />
      <DataTable
        columns={COLUMNS}
        rows={subscriptions.data}
        total={subscriptions.total}
        page={subscriptions.current_page}
        perPage={subscriptions.per_page}
        lastPage={subscriptions.last_page}
        toolbarLeft={
          <TableSearch
            value={search}
            placeholder="Search by email…"
            onChange={q => navigate({ search: q, page: 1 })}
          />
        }
        onPageChange={p => navigate({ search, page: p })}
        onPerPageChange={n => navigate({ search, per_page: n, page: 1 })}
        emptyMessage="No subscriptions found."
        selectable={false}
      />
    </>
  )
}

SubscriptionsPage.layout = (page: React.ReactNode) => (
  <AdminLayout title="Subscriptions">{page}</AdminLayout>
)

export default SubscriptionsPage
